import { useEffect, useLayoutEffect } from 'react';

// `useLayoutEffect` warns during SSR because layout effects cannot run without a DOM.
// Effects of either kind are no-ops on the server, so falling back to `useEffect` there
// silences the warning while keeping the pre-paint, synchronous timing on the client that
// DOM-measuring hooks depend on to avoid a visible flash of unmeasured layout.
// The branch is evaluated once per environment (server bundle vs. browser bundle), so the
// hook identity is stable for the lifetime of a render tree and hook order never changes.
export const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
